import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { Layout } from './Layout'
import { HomePage as Home } from '../pages/HomePage'
import { ProjectsPage as Projects } from '../pages/ProjectsPage'
import { SkillsPage as Skills } from '../pages/SkillsPage'
import { ContactPage as Contact } from '../pages/ContactPage'
import { PageTransition } from './PageTransition'
import { ScrollToTop } from './ScrollToTop'

export function App() {
  const location = useLocation()

  return (
    <Layout>
      <ScrollToTop />
      <AnimatePresence mode='wait'>
        <Routes location={location} key={location.pathname}>
          <Route
            path='/'
            element={
              <PageTransition>
                <Home />
              </PageTransition>
            }
          />
          <Route
            path='/projects'
            element={
              <PageTransition>
                <Projects />
              </PageTransition>
            }
          />
          <Route
            path='/skills'
            element={
              <PageTransition>
                <Skills />
              </PageTransition>
            }
          />
          <Route
            path='/contact'
            element={
              <PageTransition>
                <Contact />
              </PageTransition>
            }
          />
        </Routes>
      </AnimatePresence>
    </Layout>
  )
}
